import React, { useContext } from "react";
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";

const TipoDispositivosScreen = ({
  listTipos,
  setSelected,
  loading,
  setShowDialog,
}) => {
  const { userAuth } = useContext(AuthContext);

  const colums = [
    {
      field: "IdTipoDispositivo",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "TipoDispositivo",
      header: "Tipo Dispositivo",
      headerEn: "Device Type",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "CodigoInterno",
      header: "CodigoInterno",
      headerEn: "Internal Code",
      flex: 1,
    },
    {
      field: "IdTipoDispositivo",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          className: "custom-tooltip",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: listTipos,
    loading: loading,
  };
  return (
    <div
      className="p-fluid"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <AgGrid table={table} />
    </div>
  );
};

export default TipoDispositivosScreen;
